<bcu-local-spinner [size]="50" [visible]="isBusy"></bcu-local-spinner>

@if (calendarData && !isBusy) {
    <div class="calendar">
        <app-camp-care-booking-calendar-nav
            [calendarData]="calendarData"
            [searchForm]="searchForm"
        ></app-camp-care-booking-calendar-nav>
        <app-camp-care-booking-calendar-body
            [calendarData]="calendarData"
        ></app-camp-care-booking-calendar-body>
    </div>
}
